import React from 'react';
import PropTypes from 'prop-types';
import { productItemShape } from '../shapes';
import ProductItem from '../containers/ProductItem';
import CheckboxButton from '../../../../common/CheckboxButton';

const ProductsTable = ({ products, allSelected, setAllSelected, isChecked, onProductToggleSelect }) => (
  <div className="c-wrapper">
    <div className="u-max-width-1000 u-margin-auto u-mv-">
      <div>
        <div className="c-table-card c-table-new c-table-card--fixed c-no-hover c-even-odd">
          <div className="c-table-card__row c-table-card__row--transparent">
            <div className="c-table-card__cell u-2/10">
              <CheckboxButton
                onClick={() => setAllSelected(!allSelected)}
                label="Select All"
                checkedLabel="Deselect All"
                checked={allSelected}
                display-if={products.length > 1}
              />
            </div>
            <div className="c-table-card__cell u-4/10 c-table-header-grey">Name</div>
            <div className="c-table-card__cell u-4/10 c-table-header-grey">Categories</div>
          </div>
          {products.length > 0 && products.map(product => (
            <ProductItem
              product={product}
              key={product.id}
              checked={isChecked(product.id)}
              onChange={onProductToggleSelect(product.id)}
            />
          ))}
        </div>
      </div>
    </div>
  </div>
);

ProductsTable.propTypes = {
  products: PropTypes.arrayOf(productItemShape).isRequired,
  allSelected: PropTypes.bool.isRequired,
  setAllSelected: PropTypes.func.isRequired,
  isChecked: PropTypes.func.isRequired,
  onProductToggleSelect: PropTypes.func.isRequired,
};

export default ProductsTable;
